function outputUpdate(vol) {
  document.querySelector("#volume").value = vol;
}

$(function () {
  $("body").on("click", ".filter-left-filter-headline", function () {
    $(this).parents(".filter-left-area-container").find("ul").toggle();
  });

  let locale = $("body").data("shop-locale");

  //close filter on mobile when clicking outside of it

  var isMobile = /Android|webOS|iPhone|iPod|BlackBerry/i.test(
    navigator.userAgent
  )
    ? true
    : false;

  if (isMobile) {
    $(document).on("mouseup touchend", function (e) {
      var container = $(".filter-left");

      if (
        !container.is(e.target) &&
        container.has(e.target).length === 0 &&
        container.is(":visible")
      ) {
        $(".filter-left").hide();
        $(".filter-left-mobile-overlay").hide();
        return false;
      }
    });
  }

  current_path = window.location.pathname;

  if (current_path == "/search") {
    return;
  }

  $("body").on("click", "#filter-left-mobile-close", function () {
    $(".filter-left").hide();
    $(".filter-left-mobile-overlay").hide();
    return false;
  });

  $("body").on("click", ".filter-left-remove-checked", function () {
    console.log($(this).data("checkbox-ref"));

    var ref = $(this).data("checkbox-ref");
    //$("input[data-type='"+ref+"']").iCheck('uncheck');
    $("input[data-type='" + ref + "']").prop("checked", false);
    $("input[data-type='" + ref + "']").removeClass("checked");

    $(".filter-left-begin-filtering").first().trigger("click");
  });

  $("body").on("click", ".filter-left-close", function () {
    $(".filter-left").hide();
    $(".filter-left-mobile-overlay").hide();
    return false;
  });

  $("body").on("click", ".filter-left-open", function () {
    $(".filter-left").show();
    $(".filter-left-mobile-overlay").show();
    return false;
  });

  $("body").on("click", "#filter-left-sort", function () {
    $("#filter-left-sort-list").toggle();
    return false;
  });

  $("body").on("click", "#filter-left-sort-list li a", function () {
    $("#filter-left-sort-list li a").removeClass("filter-left-sort-active");
    $(this).addClass("filter-left-sort-active");
    $("#filter-left-sort-list").toggle();

    $("#collection-sort-chosen").html($(this).html());

    if ($(".filter-left").hasClass("filter-left-active")) {
      $(".filter-left-begin-filtering").first().trigger("click");
    } else {
      var href = $(this).attr("href");
      var sort = $(this).data("sort");
      $(".products").html("Henter produkter");
      $(".products").load(href + " .products");
    }

    return false;
  });

  var shop_id = $("body").data("shop-id");

  var collection_type = $("#collection-type").data("collection-type");

  var collection_brand = $(".collection").data("collection");

  var filter_menu_brands = JSON.parse(
    localStorage.getItem("filter_" + collection_type + "_brands")
  );
  var filter_menu_types = JSON.parse(
    localStorage.getItem("filter_" + collection_type + "_types")
  );
  var filter_menu_categories = JSON.parse(
    localStorage.getItem("filter_" + collection_type + "_categories")
  );

  if (collection_type || collection_brand) {
    $.ajax({
      type: "GET",
      url: "https://thevulcan.io/api/filter_menu_items.php",
      data: {
        brand: $(".collection").data("collection"),
        limit: 4,
        shop_id: shop_id,
        collection_type: collection_type,
        locale,
      },
      dataType: "json",
      success: function (data) {
        localStorage.setItem(
          "filter_" + collection_type + "_brands",
          JSON.stringify(data.brands)
        );
        localStorage.setItem(
          "filter_" + collection_type + "_types",
          JSON.stringify(data.types)
        );
        localStorage.setItem(
          "filter_" + collection_type + "_categories",
          JSON.stringify(data.categories)
        );

        filter_checkboxes(data.brands, data.types, data.categories);

        /*
				$('input').iCheck({
				checkboxClass: 'icheckbox_minimal',
				radioClass: 'iradio_minimal'
				});
				*/
      },
    });
  }

  function filter_checkboxes(brands, types, categories) {
    $.each(brands, function (i, item) {
      var str = item.handle;
      var res = str.replace("&", "");
      $(".filter-left-brand").append(
        '<li class="' +
          res +
          '-brand"><label class="checkbox"><input type="checkbox" name="id"  data-toggle="checkbox" data-type="' +
          item.brand +
          '"  /> ' +
          item.brand +
          "</label></li>"
      );
    });

    $.each(types, function (i, item) {
      if (!item.type) {
        return;
      }
      $(".filter-left-types").append(
        '<li class="' +
          item.handle +
          '-type"><label class="checkbox"><input type="checkbox" name="id"  data-toggle="checkbox" data-type="' +
          item.handle +
          '"  /> ' +
          item.type +
          "</label></li>"
      );
    });

    $.each(categories, function (i, item) {
      $(".filter-left-categories").append(
        '<li class="' +
          item.handle +
          '-category"><label class="checkbox"><input type="checkbox" name="id"  data-toggle="checkbox" data-type="' +
          item.handle +
          '"  /> ' +
          item.category +
          "</label></li>"
      );
    });

    //hide brands if only 1
    if ($(".filter-left-brand li").length == 1) {
      $(".filter-left-brand-container").hide();
    }
  }
});

$("body").on(
  "ifToggled click",
  ".filter-left li input, .filter-left-start, .filter-left-begin-filtering",
  function (event) {
    $(".filter-left").addClass("filter-left-active");
    var filter_version = Math.random();
    localStorage.setItem("filter_version", filter_version);

    if ($(this).hasClass("checked")) {
      $(this).removeClass("checked");
    } else {
      $(this).addClass("checked");
    }

    $(".icheckbox_minimal").css("visibility", "hidden");

    $("html, body").animate(
      { scrollTop: $(".collection-with-filter").offset().top - 120 },
      "slow"
    );

    var colors = "";
    var product_types = "";
    var brands = "";
    var categories = "";
    var colors = "";
    var price = $("#filter-left-price").val();
    var on_stock = $('input[name="filter-left-stock"]:checked').length > 0;
    var sort = $(".filter-left-sort-active").data("sort");

    console.log("price: " + price);
    console.log("on stock: " + on_stock);

    product_types_count = 0;
    brands_count = 0;
    categories_count = 0;
    colors_count = 0;
    total_checked_count = 0;

    $(".filter-left-checked").html(""); //reset what is chosen

    $(".filter-left-types input.checked").each(function (i) {
      product_types += $(this).data("type") + ",";
      product_types_count++;
      total_checked_count++;

      $(".filter-left-checked").append(
        '<div class="filter-left-remove-checked" data-checkbox-ref="' +
          $(this).data("type") +
          '"  style="float:left;background: #eeee;border-radius: 8px;margin-right:5px;padding:3px 12px;  cursor:pointer;  ">' +
          $(this).data("type") +
          ' <span style="  font-size: 13px;color:red">&times;</span></div>'
      );
    });

    $(".filter-left-brand input.checked").each(function (i) {
      brands += $(this).data("type") + ",";
      brands_count++;
      total_checked_count++;

      $(".filter-left-checked").append(
        '<div class="filter-left-remove-checked" data-checkbox-ref="' +
          $(this).data("type") +
          '"  style="float:left;background: #eeee;border-radius: 8px;margin-right:5px;padding:3px 12px;  cursor:pointer; ">' +
          $(this).data("type") +
          ' <span style="  font-size: 13px;color:red">&times;</span></div>'
      );
    });

    $(".filter-left-categories input.checked").each(function (i) {
      categories += $(this).data("type") + ",";
      categories_count++;
      total_checked_count++;
    });

    $(".filter-left-colors .color-active").each(function (i) {
      colors += $(this).data("color") + ",";
      colors_count++;
      total_checked_count++;
    });

    if (product_types_count > 0) {
      $("#filter-overview-type span").show();
      $("#filter-overview-type span").html(product_types_count);
      //$("#filter-left-type-remove").show();
    } else {
      $("#filter-overview-type span").hide();
      $("#filter-left-type-remove").hide();
    }

    if (brands_count > 0) {
      $("#filter-overview-brand span").show();
      $("#filter-overview-brand span").html(brands_count);
      //$("#filter-left-brand-remove").show();
    } else {
      $("#filter-overview-brand span").hide();
      $("#filter-left-brand-remove").hide();
    }

    if (categories_count > 0) {
      $("#filter-overview-category span").show();
      $("#filter-overview-category span").html(categories_count);
      //$("#filter-left-brand-remove").show();
    } else {
      $("#filter-overview-category span").hide();
      $("#filter-left-category-remove").hide();
    }

    //do if nothing is selected
    $(".products").html(
      '<div style="color:#888;text-align:center;font-size:25px">Henter produkter...</div>'
    );

    var shop_id = $("body").data("shop-id");
    var collection_type = $("#collection-type").data("collection-type");

    if (
      product_types_count == 0 &&
      brands_count == 0 &&
      categories_count == 0 &&
      colors_count == 0 &&
      price == 0 &&
      on_stock == "false"
    ) {
      $(".filter-left-ul-container ul li").show();
      $(".icheckbox_minimal").css("visibility", "visible"); // show checkboxes again
      var current_url = window.location.href;
      $(".products").load(current_url + " .products");

      return true;
    }

    $.ajax({
      type: "GET",
      url: "https://thevulcan.io/api/filter_products.php",
      data: {
        collection: collection_type,
        product_types: product_types,
        categories: categories,
        colors: colors,
        brands: brands,
        price: price,
        on_stock: on_stock,
        sort: sort,
        shop_id: shop_id,
        filter_version: filter_version,
      },
      dataType: "json",
      success: function (data) {
        var filter_version_local = localStorage.getItem("filter_version");

        if (filter_version_local != data.filter_version) {
          console.log("does not match");
          console.log(
            "version: " + data.filter_version + " " + filter_version_local
          );
          return;
        }

        $("#filter-left-remove").show();

        $(".products").html("");

        $(".icheckbox_minimal").css("visibility", "visible"); // show checkboxes again

        $("#collection-number-of-products").html(data.products.length);

        console.log(data.products.length);

        if (!data.products) {
          $(".products").append(
            '<div class="center">Ingen produkter blev fundet</div>'
          );
        }

        if (data.products) {
          $.each(data.products, function (i, item) {
            if (shop_id == 1) {
              if (item.tags)
                if (item.tags.indexOf("horizontal") >= 0) {
                  //frame = 'https://cdn.shopify.com/s/files/1/0179/9377/t/6/assets/frame_grey_landscape.png';
                  //frame_padding = 42;
                  //image_width = 81;
                } else {
                  //frame_padding = 14;
                  //image_width = 80;
                }

              frame =
                "https://cdn.shopify.com/s/files/1/0179/9377/t/6/assets/frame_grey.png";
              frame_padding = 14;
              image_width = 80;

              if (item.image_ratio > 1.3 && item.image_ratio < 1.43) {
                frame =
                  "https://cdn.shopify.com/s/files/1/0179/9377/t/6/assets/frame_grey_landscape.png";
                frame_padding = 42;
                image_width = 81;
              }

              if (item.image_ratio > 1.44 && item.image_ratio < 1.6) {
                frame =
                  "https://cdn.shopify.com/s/files/1/0179/9377/t/6/assets/frame_grey_landscape.png";
                frame_padding = 43.5;
                image_width = 81;
              }

              if (item.image_ratio > 0.735 && item.image_ratio < 0.757) {
                image_width = 84;
              }

              if (item.image_ratio > 1.49 && item.image_ratio < 1.51) {
                image_width = 84;
              }

              $(".products").append(
                '<div class="collection-product col-md-3 col-xs-6 col-sm-6">' +
                  '<div class="image" style="position: relative;"><a href="/products/' +
                  item.handle +
                  '" class="product-open" data-keen-name="">' +
                  '<div style="position:relative;z-index:1"><img src="' +
                  frame +
                  '"></div>' +
                  '<div style="width:100%; position:absolute; text-align:center;top:0;margin-top:' +
                  frame_padding +
                  '%"><img src="' +
                  item.image_two +
                  '" alt="" style="width:' +
                  image_width +
                  '%; margin-right: 1px;"/></div>' +
                  "</a>" +
                  '<div class="product-loop-save-product" style="z-index:2; ">' +
                  '<a href="#" class="save-product save-product-' +
                  item.id +
                  '" data-product-id="' +
                  item.id +
                  '" style=""><i class="fa fa-heart-o" style=""></i></a>' +
                  "</div>" +
                  "</div>" +
                  '<div class="details">  <a href="/products' +
                  item.handle +
                  '" class="product-open"> </a>  <div class="row"><a href="/products/' +
                  item.handle +
                  '" class="product-open">    <div class="col-md-8 col-sm-7 col-xs-12 collection-product-vendor">      <h3 class="title" style="margin-bottom:5px">' +
                  item.title +
                  '</h3><div class="collection-product-vendor-vendor" notranslate=""> ' +
                  item.vendor +
                  ' </div>    </div><div class="col-md-4 col-sm-5 col-xs-12"> <div class="price right" notranslate=""> <span class="money" data-currency-dkk="' +
                  item.price +
                  ' kr.">' +
                  item.price +
                  " kr.</span> </div> </div>        </a>  </div>   </div>    </div>"
              );
            } else {
              if (item.compare_at_price > 1) {
                var compare_discount = Math.round(
                  ((item.compare_at_price - item.price) /
                    item.compare_at_price) *
                    100
                );
                var compare =
                  '<del style="margin-top:3px;display:block"><span class="money money-is-set" data-currency-dkk="' +
                  item.compare_at_price +
                  ' kr">' +
                  item.compare_at_price +
                  " kr.</span></del>";
                var compare_circle =
                  '<span class="product-circle" style="position:absolute;z-index: 1;">-' +
                  compare_discount +
                  "%</span>";
              } else {
                var compare = "";
                var compare_circle = "";
              }

              $(".products").append(
                '<div class="collection-product col-md-4 col-xs-6 col-sm-6">' +
                  compare_circle +
                  '<div class="image" style="position: relative;"><a href="/products/' +
                  item.handle +
                  '" class="product-open" data-keen-name="">' +
                  '<img src="' +
                  item.image +
                  '" alt="" /></a>' +
                  '<div class="product-loop-save-product">' +
                  '<a href="#" class="save-product save-product-' +
                  item.id +
                  '" data-product-id="' +
                  item.id +
                  '" style=""><i class="fa fa-heart-o" style=""></i></a>' +
                  "</div>" +
                  "</div>" +
                  '<div class="details">  <a href="/products' +
                  item.handle +
                  '" class="product-open"> </a>  <div class="row"><a href="/products/' +
                  item.handle +
                  '" class="product-open">    <div class="col-md-8 col-sm-7 col-xs-12 collection-product-vendor">      <h3 class="title" style="margin-bottom:5px">' +
                  item.title +
                  '</h3><div class="collection-product-vendor-vendor" notranslate=""> ' +
                  item.vendor +
                  ' </div>    </div><div class="col-md-4 col-sm-5 col-xs-12"> <div class="price right" notranslate=""> <span class="money" data-currency-dkk="' +
                  item.price +
                  ' kr.">' +
                  item.price +
                  " kr.</span> " +
                  compare +
                  " </div> </div>        </a>  </div>   </div>    </div>"
              );
            }
          });

          $.each(user_data.saved_products, function (index, value) {
            var product_id = value.product_id;
            $(".save-product-" + product_id).html(
              '<i class="fa fa-heart"></i>'
            );
          });

          //show or hide considering if any are checked
          if (total_checked_count > 0) {
            $(".filter-left-brand li").hide();
            $.each(data.brands, function (i, item) {
              $("." + item.brand + "-brand").show();
            });

            $(".filter-left-types li").hide();
            $.each(data.types, function (i, item) {
              $("." + item.type + "-type").show();
            });

            $(".filter-left-categories li").hide();
            $.each(data.categories, function (i, item) {
              $("." + item.category + "-category").show();
            });
          } else {
            $(".filter-left li").show();
          }
        } else {
          //$( ".content " ).load( "https://moodings.com/collections/bolig?view=alternate #content-ajax" );
        }

        ga("send", "event", "Filter left", "Products show", "Filter");
      },
    });

    return true;
  }
);

$("body").on(
  "click",
  ".filter-left .filter-left-colors li a",
  function (event) {
    $(this).toggleClass("color-active");

    if ($(this).hasClass("color-active")) {
      $(this)
        .find(".color-circle")
        .append(
          '<i class="fa fa-check" aria-hidden="true" style="color:#fff;padding-left: 5px;"></i>'
        );
    } else {
      $(this).find(".color-circle").html("");
    }

    delay_filter(function () {
      $(".filter-left-begin-filtering").first().trigger("click");
    }, 400);

    ga("send", "event", "Filter left option", "Filtered by color", "Filter");

    event.preventDefault();
  }
);

$("body").on("input", ".filter-left #filter-left-price", function () {
  delay_filter(function () {
    $(".filter-left-begin-filtering").first().trigger("click");
  }, 400);

  ga("send", "event", "Filter left option", "Filtered by price", "Filter");
});

var delay_filter = (function () {
  var timer = 0;
  return function (callback, ms) {
    clearTimeout(timer);
    timer = setTimeout(callback, ms);
  };
})();
